
app.commonController = app.commonController || {};
app.commonController.defaultAction = {
   
    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    init : function () {
        this.htmlDevBar();
    },

    htmlDevBar : function () {
        if($('body').hasClass('customize-support')) {
            $('html').css('height', 'calc(100% - 32px');
            $('.block-info').css('margin-top', '32px');
        }
    },


};